import { Injectable } from "@angular/core";
import { BfxFindService } from "../bfx-find/bfx-find.service";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class BfxFindDealsService extends BfxFindService {
  protected blotterName: string = "find-deals";

  constructor() {
    super();
  }
}
